export default __webpack_public_path__ + "assets/person_24dp_FILL0_wght400_GRAD0_opsz24.svg";